import {User} from '@app/core/models/user.model';
import {Tenant} from '@app/core/models/tenant.model';
import {Department} from '@app/core/models/department.model';
import {UserType} from '@app/core/services/auth.service';
import {IQOHubChain} from '@quickorder/angular-web-lib/lib/types/interfaces/q-o-hub-chain.interface';

export interface ISessionState {
	user: User;
	tenant: Tenant;
	tenants: Tenant[];
	department: Department;
	departments: Department[];
	isLoading: boolean;
	userType: UserType;

	registrationComplete: boolean;

	hub_chain: IQOHubChain;
}

export const initialSessionState: ISessionState = {
	user: undefined,
	tenant: undefined,
	department: undefined,
	departments: [],
	tenants: [],
	isLoading: false,
	userType: !localStorage.getItem('userType') ? undefined : (localStorage.getItem('userType') as UserType),

	registrationComplete: false,

	hub_chain: null,
};
